import React from "react";
import HeroSection from "../common/HeroSection";
import OdooServices from "./OdooServices";
import { AppWindowIcon, ArrowUpRightSquare, BugIcon, CircleCheckBig, Database, TestTubes } from "lucide-react";
import { BiSupport } from "react-icons/bi";

export default function OdooUpgrades() {
  return (
    <div>
      <HeroSection
        title="Odoo Upgrades"
        breadcrumb={[
          { name: "Services", url: "/services" },
          { name: "Odoo Services", url: "/services/odoo-services" },
          {
            name: "Odoo Upgrades",
            url: "/services/odoo-services/odoo-upgrades",
          },
        ]}
        background="/assets/images/about/bg.png"
      />

      <div className="bg-white">
        <div className="py-16 px-4 mx-auto container">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 px-4">
            <OdooServices />

            <div className="lg:col-span-2">
              <div className="relative rounded-xl overflow-hidden mb-8">
                <img
                  alt="Odoo Upgrades"
                  className="w-full h-auto object-cover rounded-xl"
                  src="/assets/images/odoo/odooupgrade.webp"
                />
              </div>

              <div className="mb-8">
                <span className="text-primary font-medium text-lg inline-block py-1 font-bold rounded-full bg-primary bg-opacity-10 mb-3">
                  Stay Ahead with the Latest Odoo Version
                </span>
                <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">
                  Odoo <span className="text-primary">Upgrades</span>
                </h2>
                <div className="prose prose-lg max-w-none text-gray-600">
                  <p>
                    Odoo Upgrade services help businesses seamlessly move from
                    an older Odoo version to the latest release, ensuring access
                    to new features, improved performance, and better security.
                  </p>
                  <p>
                    Seamlessly migrate to the latest Odoo version with our
                    expert upgrade services. We ensure smooth data migration,
                    module compatibility, and system optimization so you can
                    unlock new features, improved performance, and enhanced
                    security—without disruptions.
                  </p>
                </div>
              </div>

                <div className="mb-12">
                <h3 className="text-2xl font-bold text-gray-800 mb-6">
                  Key Services
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="bg-white p-6 rounded-xl shadow-soft border border-gray-100 hover:shadow-md transition-shadow duration-300">
                    <div className="bg-primary bg-opacity-10 p-3 rounded-full inline-flex items-center justify-center mb-4">
                      <Database className="h-6 w-6 text-primary" />
                    </div>
                    <h4 className="text-xl font-semibold text-gray-800 mb-2">
                      Database Migration
                    </h4>
                    <p className="text-gray-600">
                      Safely migrating existing data, records, and configurations to the new version.
                    </p>
                  </div>
                  <div className="bg-white p-6 rounded-xl shadow-soft border border-gray-100 hover:shadow-md transition-shadow duration-300">
                    <div className="bg-primary bg-opacity-10 p-3 rounded-full inline-flex items-center justify-center mb-4">
                      <ArrowUpRightSquare className="h-6 w-6 text-primary" />
                    </div>
                    <h4 className="text-xl font-semibold text-gray-800 mb-2">
                      Custom Module Upgrade
                    </h4>
                    <p className="text-gray-600">
                      Updating and adapting custom modules to be compatible with the latest Odoo framework.
                    </p>
                  </div>
                  <div className="bg-white p-6 rounded-xl shadow-soft border border-gray-100 hover:shadow-md transition-shadow duration-300">
                    <div className="bg-primary bg-opacity-10 p-3 rounded-full inline-flex items-center justify-center mb-4">
                      <AppWindowIcon className="h-6 w-6 text-primary" />
                    </div>
                    <h4 className="text-xl font-semibold text-gray-800 mb-2">
                      Third-Party App Migration
                    </h4>
                    <p className="text-gray-600">
                     Ensuring external apps and connectors work smoothly post-upgrade.
                    </p>
                  </div>
                  <div className="bg-white p-6 rounded-xl shadow-soft border border-gray-100 hover:shadow-md transition-shadow duration-300">
                    <div className="bg-primary bg-opacity-10 p-3 rounded-full inline-flex items-center justify-center mb-4">
                      <TestTubes className="h-6 w-6 text-primary" />
                    </div>
                    <h4 className="text-xl font-semibold text-gray-800 mb-2">
                      Testing & Validation
                    </h4>
                    <p className="text-gray-600">
                      Functional and technical testing to guarantee stability, accuracy, and performance.
                    </p>
                  </div>
                  <div className="bg-white p-6 rounded-xl shadow-soft border border-gray-100 hover:shadow-md transition-shadow duration-300">
                    <div className="bg-primary bg-opacity-10 p-3 rounded-full inline-flex items-center justify-center mb-4">
                      <BugIcon className="h-6 w-6 text-primary" />
                    </div>
                    <h4 className="text-xl font-semibold text-gray-800 mb-2">
                      Bug Fixes & Optimization
                    </h4>
                    <p className="text-gray-600">
                     Identifying and fixing issues, improving efficiency.
                    </p>
                  </div>
                  <div className="bg-white p-6 rounded-xl shadow-soft border border-gray-100 hover:shadow-md transition-shadow duration-300">
                    <div className="bg-primary bg-opacity-10 p-3 rounded-full inline-flex items-center justify-center mb-4">
                      <BiSupport className="h-6 w-6 text-primary" />
                    </div>
                    <h4 className="text-xl font-semibold text-gray-800 mb-2">
                      Training & Support
                    </h4>
                    <p className="text-gray-600">
                     User guidance and post-upgrade support to ensure smooth adoption.
                    </p>
                  </div>
                </div>
              </div>

              <div className="mb-12">
                <h3 className="text-2xl font-bold text-gray-800 mb-6">
                  Benefits
                </h3>
                <div className="bg-gray-50 p-6 rounded-xl border-l-4 border-primary">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="flex items-start">
                      <CircleCheckBig className="h-5 w-5 text-primary mr-3 mt-1" />
                      <span className="text-gray-700">
                       Access to latest features and functionalities
                      </span>
                    </div>
                    <div className="flex items-start">
                      <CircleCheckBig className="h-5 w-5 text-primary mr-3 mt-1" />
                      <span className="text-gray-700">
                        Better speed, security, and performance
                      </span>
                    </div>
                    <div className="flex items-start">
                      <CircleCheckBig className="h-5 w-5 text-primary mr-3 mt-1" />
                      <span className="text-gray-700">
                        Reduced technical debt
                      </span>
                    </div>
                    <div className="flex items-start">
                      <CircleCheckBig className="h-5 w-5 text-primary mr-3 mt-1" />
                      <span className="text-gray-700">
                       Enhanced user experience
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-8 rounded-xl border border-blue-100">
                  <h4 className="text-2xl font-bold text-gray-800 mb-3">
                    Ready to Upgrade Your Odoo System?
                  </h4>
                  <p className="text-gray-600 mb-6">
                    Contact our Odoo upgrade specialists to discuss how we can
                    help you move to the latest version safely and efficiently.
                  </p>
                  <div className="flex flex-col sm:flex-row gap-4">
                    <a
                      className="inline-block text-blue-700 font-bold bg-primary hover:bg-primary-dark py-3 px-6 rounded-lg transition-colors duration-300"
                      href="/contact-us/"
                    >
                      Request a Free Consultation
                    </a>
                    <a
                      className="inline-block border border-primary text-primary hover:bg-blue-700 hover:text-white py-3 px-6 rounded-lg transition-colors duration-300"
                      href="/services/odoo-services/"
                    >
                      Explore All Odoo Services
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-3xl font-bold text-center text-gray-800 mb-8">
              Frequently Asked Questions
            </h2>
            <div className="space-y-6">
              <div className="bg-white p-6 rounded-xl shadow-soft">
                <h3 className="text-xl font-bold text-gray-800 mb-2">
                  Is upgrading to the latest Odoo version necessary?
                </h3>
                <p className="text-gray-600">
                  Yes. Upgrading helps you benefit from performance
                  enhancements, improved security, and new features that
                  streamline your business processes.
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-soft">
                <h3 className="text-xl font-bold text-gray-800 mb-2">
                  How long does the upgrade process take?
                </h3>
                <p className="text-gray-600">
                  The timeline varies based on your current Odoo version and
                  customization level. Typical upgrades range from 2 to 6 weeks.
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-soft">
                <h3 className="text-xl font-bold text-gray-800 mb-2">
                  Will my existing data be preserved during the upgrade?
                </h3>
                <p className="text-gray-600">
                  Absolutely. We take backups and perform test upgrades to
                  ensure your data is accurately migrated and remains intact.
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-soft">
                <h3 className="text-xl font-bold text-gray-800 mb-2">
                  What if I have custom modules in my current version?
                </h3>
                <p className="text-gray-600">
                  We assess all custom modules for compatibility and refactor or
                  redevelop them as needed for the upgraded version.
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-soft">
                <h3 className="text-xl font-bold text-gray-800 mb-2">
                  Do you provide post-upgrade support?
                </h3>
                <p className="text-gray-600">
                  Yes. We offer ongoing support, bug fixes, and performance
                  monitoring to ensure everything runs smoothly after your
                  upgrade.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
